import React from 'react'
import Coverart from '@components/app/coverart'
import ImageUploader from '@components/app/image-uploader'
import { ProgressBar } from '@components/common/progress'
import Spinner from '@components/common/spinner'
import classnames from 'classnames'
import { FormattedMessage } from 'react-intl'
import styles from './coverart.module.scss'


interface Props {
  className?: string
  src: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onCompleted: (f: any) => void
}

const ImgUploader = ({ src, className, onCompleted }: Props) => (
  <ImageUploader onChange={onCompleted}>
    {(
      { getRootProps, getInputProps, isDragActive },
      tmpImage,
      isUploading,
      progress,
    ) => (
      <div
        className={classnames(className, styles.imgUploader, 'relative', {
          [styles.droppable]: !isUploading,
        })}
      >
        <div className={styles.uploadContainer}>
          <div
            className={classnames(styles.btn, {
              [styles.active]: isDragActive,
            })}
            {...getRootProps()}
          >
            <div className={`${styles.content} tx-center`}>
              {isUploading ? (
                <Spinner size={64} className="mb-2" />
              ) : (
                <i className={`solicon-camera ${styles.iconPhoto} mb-2`} />
              )}
              <p className="tx-16 tx-center tx-w500 mb-0 px-3">
                {isUploading ? (
                  <FormattedMessage
                    id="sound.edit.uploading"
                    defaultMessage="Uplaoding {progress}%"
                    values={{ progress: Math.floor(progress) }}
                  />
                ) : (
                  <FormattedMessage
                    id="sound.edit.cover"
                    defaultMessage="Change cover photo"
                  />
                )}
              </p>
            </div>
          </div>
          {tmpImage ? (
            <img
              className={classnames({ [styles.uploading]: isUploading })}
              src={tmpImage}
              width="100%"
              alt=""
            />
          ) : (
            <Coverart
              className={classnames({ [styles.uploading]: isUploading })}
              src={src}
              alt=""
            />
          )}
          {isUploading && (
            <div className={styles.progress}>
              <ProgressBar value={progress} max={100} height={2} stripe />
            </div>
          )}
          <input {...getInputProps()} />
        </div>
      </div>
    )}
  </ImageUploader>
)

ImgUploader.defaultProps = {
  className: '',
}

export default ImgUploader
